import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export const getQueryResult = (queryHttpRequestOptions: AxiosRequestConfig) =>
  axios
    .request(queryHttpRequestOptions)
    .then((response: AxiosResponse) => response.data)
    .catch((err) => {
      console.log("err: ", err);
    });
